<agr-form-dialog
  [formGroup]="formGroup"
  (confirm)="save()"
  (alt)="alt()"
  (cancel)="cancel()"
  [data]="data"
>
  <div>
    <h4>{{ 'wdo-settings.weekly-daily-description' | translate }}</h4>
    <div class="flex--column">
      <mat-label class="text--bold text--small">
        {{ 'wdo-settings.general-option.label' | translate }}
      </mat-label>
      <mat-radio-group formControlName="generalSetting">
        <mat-radio-button
          data-test="wdo-settings__general-setting-per-day"
          class="text--small"
          color="primary"
          [value]="'PerDay'"
        >
          {{ 'wdo-settings.general-option.per-day' | translate }}
        </mat-radio-button>
        <mat-radio-button
          data-test="wdo-settings__general-setting-per-week"
          class="text--small"
          color="primary"
          [value]="'PerWeek'"
        >
          {{ 'wdo-settings.general-option.per-week' | translate }}
        </mat-radio-button>
      </mat-radio-group>
    </div>

    <div formArrayName="wdoSettings" class="spacing--margin-top">
      <app-setting
        *ngFor="let control of wdoSettings().controls; index as i"
        [formControlName]="i"
        [settingName]="wdoSettingsArray[i]"
        [value]="control.value"
      >
      </app-setting>
    </div>
  </div>
</agr-form-dialog>
